module.exports = __webpack_public_path__ + "img/goods-4.e1ad57f3.png";